import { IProductItem } from '@core/models/interfaces/product/product-item.interface';
import { environment } from '@env/environment';

export class ProductItem {
  id!: number;
  name!: string;
  description!: string;
  value!: number;
  maxOrderQuantity!: number;
  minimumPrize!: number;
  maximumPrize!: number;
  imageUrl!: string;
  imageMobileUrl!: string;
  maximumSecondaryPrize!: number;

  constructor(data: IProductItem) {
    Object.assign(this, data);
    this.description = `campanha ${data.name}`;
    this.imageUrl = this.getUrlImage(data.id, 'resultado-xl-203x114.webp');
    this.imageMobileUrl = this.getUrlImage(
      data.id,
      'resultado-xs-310x174.webp'
    );
  }

  getUrlImage(productId: number, image: string): string {
    return `${environment.endpoint.assets}/campanhas/${productId}/img/titulo/${image}`;
  }
}
